/**
 * 平台检测统一入口，避免各处重复写 process.env.REACT_APP_DEPLOY_ENV === 'xxx'
 * 所有平台判断集中在此，便于维护与扩展
 */

const DEPLOY_ENV = process.env.REACT_APP_DEPLOY_ENV || '';
/** 当前部署环境（只读一次） */
export function getDeployEnv(): string {
  return DEPLOY_ENV || '';
}

/** 是否为指定平台（精确匹配） */
export function isPlatform(name: string): boolean {
  return DEPLOY_ENV === name;
}

/** 是否为指定平台或其 Test 环境，如 isPlatformOrTest('shopify') => shopify | shopifyTest */
export function isPlatformOrTest(name: string): boolean {
  return DEPLOY_ENV === name || DEPLOY_ENV === name + 'Test';
}

/** 是否为任意 Test 环境 */
export function isTestDeployEnv(): boolean {
  return DEPLOY_ENV.endsWith('Test');
}

// ---------- 各平台便捷方法 ----------
export const isShopifyOrTest = (): boolean => isPlatformOrTest('shopify');
export const isCommonOrTest = (): boolean => isPlatformOrTest('common');
export const isSimpleOrTest = (): boolean => isPlatformOrTest('simple');
export const isXikeOrTest = (): boolean => isPlatformOrTest('xike');
export const isShoplineOrTest = (): boolean => isPlatformOrTest('shopline');
export const isShoplazzaOrTest = (): boolean => isPlatformOrTest('shoplazza');
export const isShopyyOrTest = (): boolean => isPlatformOrTest('shopyy');
export const isWooCommerceOrTest = (): boolean => isPlatformOrTest('woocommerce');

/** common / commonTest / simple / simpleTest 任一 */
export function isCommonSimpleOrTest(): boolean {
  return isCommonOrTest() || isSimpleOrTest();
}

/**
 * 是否走 formEventV2 等表单接口的部署环境（api.ts 等处的长列表）
 * 包含：shopify、shopline、shoplazza、xike、common、simple、woocommerce、shopyy 及其 Test
 */
export function isFormEventDeployEnv(): boolean {
  return (
    isShopifyOrTest() ||
    isShoplineOrTest() ||
    isShoplazzaOrTest() ||
    isXikeOrTest() ||
    isCommonSimpleOrTest() ||
    isWooCommerceOrTest() ||
    isShopyyOrTest()
  );
}

/** 是否 SaaS 建站平台（shopify/shopline/shoplazza/shopyy 及其 Test），用于 logic 等 */
export function isSaaSPlatform(): boolean {
  return isShopifyOrTest() || isShoplineOrTest() || isShoplazzaOrTest() || isShopyyOrTest();
}
